import styled from 'styled-components';

export const ValidatorPass = styled.div`
  > p {
    font-weight: 'bold';
    font-size: 1vw;
    > img {
      width: 15px;
      height: 15px;
      margin-right: 2%;
    }
  }
`;
